import React from 'react'

const AboutUs = () => {
	return (
		<div>
			<h1>About us</h1>
		</div>
	)
}

export default AboutUs
